import * as Msdyn365 from '@msdyn365-commerce/core';
import { createObservableDataAction, IAction, IActionContext, ICreateActionContext } from '@msdyn365-commerce/core';
// import { DataServiceQuery, IQueryResultSettings } from '@msdyn365-commerce/retail-proxy';
// import { lDSPolicyQuery, lDSPublisherPolicyAsync } from './DataActionExtension.g';
import { lDSPublisherPolicyAsync } from './DataActionExtension.g';
import { IChurchRetailChannelPolicyEntity } from './DataServiceEntities.g';

/**
 * GetPolicyInput Input Action
 */
export class GetPolicyInput implements Msdyn365.IActionInput {
    constructor(ctx: Msdyn365.IRequestContext) {
        this.policyName = ctx.query ? ctx.query.policy : 'Sales & Refund Terms and Conditions';
        this.locale = ctx.locale;
    }

    public getCacheKey = () => `PolicyInfo-${this.policyName}-${this.locale}`;
    public getCacheObjectType = () => 'PolicyInfo';
    public dataCacheType = (): Msdyn365.CacheType => 'request';

    public policyName: string;
    public locale: string;
}

async function action(input: GetPolicyInput, ctx: IActionContext): Promise<IChurchRetailChannelPolicyEntity> {
    // const policyName = ctx.requestContext.query ? ctx.requestContext.query.policy : 'Sales & Refund Terms and Conditions';
    return lDSPublisherPolicyAsync({ callerContext: ctx }, input.policyName);
}

export default createObservableDataAction({
    action: <IAction<IChurchRetailChannelPolicyEntity>>action,
    input: (context: ICreateActionContext) => {
        return new GetPolicyInput(context.requestContext);
    }
});
